import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';

@Injectable({
  providedIn: 'root',
})
export class TwitterService extends ApiConfig {
  constructor(private http: HttpClient) {
    super();
  }
  buscar(idProjetoLista, tags) {
    return new Promise(async (resolve) => {
      this.http
        .post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Twitter/Buscar', { idProjetoLista, tags })
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => { }
        );
    });
  }
  obter(id) {
    return new Promise(async (resolve) => {
      this.http
        .get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Twitter/Obter?Id='+id)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => { }
        );
    });
  }
  listarRecentes() {
    return new Promise(async (resolve) => {
      this.http
        .get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Twitter/ListarRecentes')
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => { }
        );
    });
  }
  listarPorTag(tags) {
    return new Promise(async (resolve) => {
      this.http
        .get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Twitter/listarPorTag?' + tags)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => { }
        );
    });
  }
}
